import { RestSlice } from 'src/redux/rest.slice';
import { CleaningNoticeTemplateSchedule, LookupType } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cleaningNoticeTemplateSlice = new RestSlice<CleaningNoticeTemplateSchedule>(
	localizationService.getLocalizedString('authoritySetting.noticesSettings.noticeTemplate'),
	`${Resource.Settings}/${LookupType.CleaningNoticeTemplateSchedule}`
);
export default cleaningNoticeTemplateSlice.rests.reducer;
